import api from '../api/api'
import url from '../api/env'

const getBrands = async (brand = '', excludeChars, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.Brands_options}?sort_type=${sort_type}&per_page=100&name=%${encodeURIComponent(brand)}%` : encodeURI(`${url.stage.Brands_options}?sort_type=${sort_type}&per_page=100&name=%${brand}%`), {})
    .then(res => res)
    .catch(err => err)

export default {
  getBrands,
}
